import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './DashboardOpportunityLayout.module.css';
export default function DashboardOpportunityLayout({ title, description, children }) {
    return (_jsxs("div", { className: styles.layout, children: [_jsx("h1", { className: styles.title, children: title }), _jsx("p", { className: styles.description, children: description }), children] }));
}
